import { IAllCollectionRepository } from '@modules/collections/application/ports/allCollection.repository.port';
import { AllCollectionQueryDocument } from '@modules/libs/graphql/generated/graphql';
import { gqlQuery } from '@modules/libs/graphql/gql-config';
import { left, right } from '@shared/utils/either.utils';
import { AllCollectionEntityMapper } from '../../outbound/ports/allCollection.mapper';
export class AllCollectionRepositoryImpl implements IAllCollectionRepository {
  async getAllCollection(offset: number, limit?: number): IAllCollectionRepository.getAllCollectionOutput {
    try {
      const {
        data
      } = await gqlQuery({
        query: AllCollectionQueryDocument,
        variables: {
          pagination: {
            limit: limit ? limit : null,
            offset
          }
        }
      });
      const result = AllCollectionEntityMapper.toDomain(data.getAllCollection);
      return right(result);
    } catch (error: any) {
      console.error('error IAllCollectionRepository.getAllCollectionOutput', error);
      return left(error);
    }
  }
}